import { getRefreshToken, saveTokens, clearTokens } from './tokens';
const AUTH_BACKEND = import.meta.env.VITE_AUTH_BACKEND_URL;
let inflight = null;
export function refreshAccessToken() {
    if (inflight)
        return inflight;
    inflight = (async () => {
        try {
            const rt = getRefreshToken();
            if (!rt || !AUTH_BACKEND)
                return null;
            const res = await fetch(`${AUTH_BACKEND}/auth/jwt/refresh`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ refresh_token: rt }),
            });
            if (!res.ok) {
                clearTokens();
                return null;
            }
            const data = (await res.json());
            if (data.access_token) {
                saveTokens(data.access_token, data.refresh_token ?? rt);
                return data.access_token;
            }
            clearTokens();
            return null;
        }
        catch (e) {
            console.error('refreshAccessToken failed', e);
            clearTokens();
            return null;
        }
        finally {
            inflight = null;
        }
    })();
    return inflight;
}
